import { render, staticRenderFns } from "./SystemTabContent.vue?vue&type=template&id=e57c4528&"
import script from "./SystemTabContent.vue?vue&type=script&lang=js&"
export * from "./SystemTabContent.vue?vue&type=script&lang=js&"
import style0 from "./SystemTabContent.vue?vue&type=style&index=0&id=e57c4528&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports